/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import {
  Container,
  Row,
  Col,
  DropdownMenu,
  CountryInput,
  Button,
} from '@paypalcorp/pp-react'
import {
  sbCountries,
  cardOptions,
} from '../../../utils/creditcardgenerator/ccgdata'
import { creditCardGenerator } from '../../../utils/creditcardgenerator/ccghelper'
import './creditcardgenerator.css'

function CreditCardGenerator() {
  const [selectedCC, setSelectedCC] = useState('Visa')
  const [selectedCountry, setSelectedCountry] = useState('US')
  const [generatedCard, setGeneratedCard] = useState()
  const [error, setError] = useState()

  const generateCard = () => {
    setError(null)
    const generatedCreditCard = creditCardGenerator(selectedCC, selectedCountry)

    if (generatedCreditCard.message) {
      setError(generatedCreditCard)
    } else {
      setGeneratedCard(generatedCreditCard)
    }
  }

  useEffect(() => {
    generateCard()
  }, [])

  return (
    <Container className="ccg-container" fluid={true}>
      <h2 className="ccg-heading1 ">Credit card generator for testing</h2>
      <Row>
        <Col>
          <div className="ccg-description">
            Generate random credit cards for testing purposes. You can add
            credit cards to a Sandbox PayPal account or use them for credit card
            payments.
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="ccg-border-bottom">
            <h2 className="ccg-heading2 ">Generate credit card</h2>
          </div>
        </Col>
      </Row>
      <br />
      <Row>
        <Col lg={6} style={{ zIndex: '998' }}>
          <DropdownMenu
            id="simple"
            autoComplete="off"
            label="Card Type"
            options={cardOptions}
            value={selectedCC}
            onChange={(e) => {
              setSelectedCC(e.target.value)
            }}
          />
        </Col>
      </Row>
      <br />
      <Row>
        <Col lg={6} style={{ zIndex: '9' }}>
          <CountryInput
            countryList={sbCountries}
            name="country-input"
            value={selectedCountry}
            isLoadingOptions={sbCountries?.length === 0}
            onChange={(e) => setSelectedCountry(e.target.value)}
            theme="v2"
          />
        </Col>
      </Row>
      <br />
      <Row>
        <Col>
          <Button onClick={generateCard} size="sm" className="ccg-button">
            Generate credit card
          </Button>
        </Col>
      </Row>
      <br />
      <Row>
        <Col>
          <div className="ccg-border-bottom">
            <h2 className="ccg-heading2 ">Generated Credit Card Details</h2>
          </div>
        </Col>
      </Row>
      <br />
      {error && (
        <Row>
          <Col>
            <span data-error>Error: </span>
            <span>{error?.message}</span>
          </Col>
        </Row>
      )}
      {generatedCard && (
        <div className="ccg-details">
          <Row>
            <Col>
              <span>Card Type: </span>
              <span>{generatedCard?.card_type}</span>
            </Col>
          </Row>
          <Row>
            <Col>
              <span style={{ fontWeight: 'bold' }}>Card Number: </span>
              <span>{generatedCard?.card_number}</span>
            </Col>
          </Row>
          <Row>
            <Col>
              <span style={{ fontWeight: 'bold' }}>Expiration Date: </span>
              <span>
                {generatedCard?.expiry_month}/{generatedCard?.expiry_year}
              </span>
            </Col>
          </Row>
          <Row>
            <Col>
              <span style={{ fontWeight: 'bold' }}>CVV: </span>
              <span>{generatedCard?.cvv2}</span>
            </Col>
          </Row>
        </div>
      )}
    </Container>
  )
}

export default CreditCardGenerator
